<template>
  <div class="app-container">
    <div style="display: flex; justify-content: end">
      <el-input
        style="float: right; margin-right: 10px; width: 200px"
        v-model="screen.like"
        placeholder="请输入车牌号、申请人姓名或手机号"
      ></el-input>

      <el-select
        filterable
        style="float: right; margin-right: 10px"
        v-model="screen.status"
        placeholder="请选择审核状态"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.title"
          :value="item.id"
          v-for="(item, index) in statusList"
          :key="index"
        ></el-option>
      </el-select>
      <!-- <el-select
        filterable
        style="float: right; margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select> -->
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px; float: right"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px; float: right"
        >重置</el-button
      >
    </div>

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <!-- <el-table-column label="园区" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column> -->

      <el-table-column label="申请人姓名" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.user ? scope.row.user.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.user ? scope.row.user.phone : "" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="车牌号" width="200" align="center">
        <template slot-scope="scope">
          <div :key="index" v-for="(item,index) in scope.row.car_lists">
            <i style="color: #67C23A;" v-if="item.car_number == scope.row.car_number"  class="el-icon-star-on"></i>
            {{ item.car_number }}
          </div>
          <!-- <span>{{ scope.row.car_number }}</span> -->
        </template>
      </el-table-column>
      <!-- <el-table-column label="续费状态">
        <template slot-scope="scope">
          <span>{{
            scope.row.renew_status == 1
              ? "待续费"
              : scope.row.renew_status == 2
              ? "正常"
              : ""
          }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="状态"  align="center">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.status == '1'
                ? 'success'
                : scope.row.status == '0'
                ? 'info'
                : 'danger'
            "
            disable-transitions
            >{{
              scope.row.status == 1
                ? "通过"
                : scope.row.status == 0
                ? "待审核"
                : "驳回"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="申请时间" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.start_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.end_time }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="examine(scope.row.id)"
            v-if="roles.includes('/carport/examine') && scope.row.status == 0"
            >审批</el-button
          >
          <!-- <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/carport/del_apply')"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-dialog
      title="审批"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item
          label="审核"
          prop="status"
          :rules="[
            { required: true, message: '请选择审核', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="form.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="reason" label="驳回意见" v-if="form.status == 2">
          <el-input type="textarea" v-model="form.reason"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark } from "@/api/index";
import { sub_apply_list, applyDel, sub_examine } from "@/api/parking";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      statusList: [
        {
          title: "通过",
          id: 1,
        },
        {
          title: "已驳回",
          id: 2,
        },
        {
          title: "待审核",
          id: 0,
        },
      ],
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      dialogVisible: false,
      form: {
        id: "",
        status: "",
        reason: "",
      },
      rules: {
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    // this.getPark();
  },
  methods: {
    examine(id) {
      this.form = {
        id: id,
        status: 1,
        reason: "",
      };
      this.dialogVisible = true;
    },
    reset() {
      this.screen = {
        park_id: "",
        page: 1,
        page_size: 15,
        like: "",
        status: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          applyDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          sub_examine(that.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.dialogVisible = false;
              that.fetchData();
            }
          });
          // this.$confirm("确认提交？")
          //   .then(() => {

          //     add_banner(that.ruleForm).then((res) => {
          //       if (res.code === 200) {
          //         that.drawer = false;
          //         that.fetchData();
          //       }
          //     });
          //   })
          //   .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      sub_apply_list(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
</style>
